import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  municipalityId: number,
 *  municipalityName: string,
 *  baseAmount: number,
 *  annualTarget: number,
 *  averageAnnualInvestment: number,
 *  periodStart: number,
 *  periodEnd: number,
 *  status: string,
 *  ammendmentMade: boolean }} IncrementalityMonitoringModalData
 */

/**
 * @typedef {{
 *  municipalityId: number,
 *  baseAmount: number,
 *  amendmentMade: boolean }} IncrementalityUpdateRequest
 */

/**
 * @typedef {{
 *  municipalityId: number,
 *  amount: number,
 *  periodEnd: number }} IncrementalityMonitoringItem
 */

const api = new Api("api/amo/review/incrementality-monitoring");

/**
 * @param {number} municipalityId
 * @returns {Promise<AxiosResponse<IncrementalityMonitoringModalData>>}
 */
export const getByMunicipality = (municipalityId) =>
  api.get(`${municipalityId}`);

/**
 * @param {number} municipalityId
 * @param {IncrementalityUpdateRequest} payload
 * @returns {Promise<AxiosResponse>}
 */
export const putMunicipalityData = (municipalityId, payload) =>
  api.put(`${municipalityId}`, payload);

/**
 * @param {IncrementalityMonitoringItem[]} payload
 * @returns {Promise<AxiosResponse>}
 */
export const updateIncrementalityMonitoringData = (payload) =>
  api.put("", payload);
